/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2024, Zumper
 */

import type { Location } from '@zcode/state-type'

export function hasLatAndLng(
  location: Location
): location is Location & { readonly [Key in 'lat' | 'lng']: NonNullable<Location[Key]> } {
  return !!(location.lat && location.lng)
}
